import React, {useState} from 'react';
import {observer} from "mobx-react";

import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PropTypes from "prop-types";
import {useStores} from "../../Hooks";
import ConditionalComponent from "./ConditionalComponent";

const QuickActionDropdown = observer(({
                                          dotsAnchor,
                                          menuActions,
                                          parentControlled,
                                          toggleMenu,
                                          menuOpen,
                                          menuAnchor,
                                          horizontalDots,
                                          transformOrigin,
                                          anchorOrigin,
                                      }) => {
    const {dragStore, generalStore} = useStores();
    const [anchor, setAnchor] = useState(null);

    function openMenu(event) {
        dragStore.isBlocked = true;
        event.preventDefault();
        event.stopPropagation();
        parentControlled
            ? toggleMenu(event.target)
            : setAnchor(event.target)

    }

    function closeMenu(event) {
        dragStore.isBlocked = false;
        event.preventDefault();
        event.stopPropagation();
        parentControlled
            ? toggleMenu(null)
            : setAnchor(null)
    }

    function renderMenuActions() {
        const menuItem = [];
        for (const key in menuActions) {
            if (!menuActions.hasOwnProperty(key)) {
                continue;
            }
            const menuProps = menuActions[key];
            const callback = menuProps?.callback || null;
            const classStr = menuProps?.classStr || '';
            let MenuIcon = menuProps?.MenuIcon || '';
            menuItem.push(
                <MenuItem
                    disabled={!callback}
                    className={`dropdown-item${classStr}`}
                    data-testid={`quick-action-${key}`}
                    key={key}
                    onClick={(event) => {
                        dragStore.isBlocked = false;
                        event.stopPropagation();
                        if (!!callback) {
                            callback(event)
                        }
                    }}
                >
                    <ConditionalComponent if={!!MenuIcon}>
                        <MenuIcon/>
                    </ConditionalComponent> {generalStore.translate(key)}
                </MenuItem>
            )
        }
        return menuItem;
    }

    return (
        <div className={'quick-action-dropdown-menu ' + dotsAnchor}>
            <IconButton data-testid="quick-action-menu-button" onClick={openMenu}>
                {horizontalDots
                    ? <MoreHorizIcon fontSize='large'/>
                    : <MoreVertIcon fontSize='large'/>
                }
            </IconButton>
            <Menu
                className='quick-action-menu'
                transformOrigin={transformOrigin ? transformOrigin : {
                    vertical: 'top',
                    horizontal: 'right',
                }}
                anchorOrigin={anchorOrigin ? anchorOrigin : {
                    vertical: 'top',
                    horizontal: 'left'
                }}
                open={parentControlled ? menuOpen : !!anchor}
                onClose={closeMenu}
                anchorEl={parentControlled ? menuAnchor : anchor}

                TransitionProps={{
                    onEnter: () => generalStore.forceStopDataPoll = true,
                    onExit: () => generalStore.forceStopDataPoll = false
                }}
                disableAutoFocusItem
            >
                {renderMenuActions()}
            </Menu>
        </div>
    )
});


QuickActionDropdown.propTypes = {
    dotsAnchor: PropTypes.oneOf(['start', 'end', 'end top']),
};

export default QuickActionDropdown;
